import { createStyles } from 'antd-style';

import { spaceBetween } from '../../../styles/mixins';
import { responsiveMdVsLg } from '../../../styles/responsiveMixins';
import { ThemeSpaces } from '../../../theme';

export const usePackageListPackagePreviewModeStyles = createStyles(
  ({ token }) => ({
    newShipmentPackageControlButtons: {
      display: 'flex',
      alignItems: 'center',

      '.IconButton': {
        display: 'inline-block',
        color: token.colorWhite,
        ...spaceBetween(ThemeSpaces.SPACE_NORM),
      },
    },
    newShipmentPackagePreviewRow: {
      padding: `${ThemeSpaces.SPACE_NORM}px 0`,

      '> .ant-row': {
        marginBottom: -ThemeSpaces.SPACE_NORM,
        '> .ant-col': {
          marginBottom: ThemeSpaces.SPACE_NORM,
        },
      },
    },
    newShipmentPackagePreviewRowCols: {
      '> .ant-col': {
        ...responsiveMdVsLg(
          {
            '&.size-sm-1': { width: '29%' },
            '&.size-sm-2': { width: '33%' },
            '&.size-sm-3': { width: '38%' },
            '&.size-sm-4': { width: '62%' },
          },
          {
            '&.size-lg-1': { width: '20%' },
            '&.size-lg-2': { width: '22%' },
            '&.size-lg-3': { width: '26%' },
            '&.size-lg-4': { width: '32%' },
          }
        ),
      },
    },
    newShipmentPackageDeviceAddons: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      counterReset: 'device-addons',

      li: {
        display: 'flex',
        marginTop: token.marginXXS,
        marginBottom: ThemeSpaces.SPACE_NORM0_5,
        counterIncrement: 'device-addons',

        '&::before': {
          width: 22,
          content: "counter(device-addons) '). '",
        },
      },
    },
  })
);
